import React, { Fragment } from "react";

import Backdrop from "../backdrop/backdrop";
import Modal from "../modal/modal";

const Error = (props) => (
  <Fragment>
    {props.error && <Backdrop onClick={props.onHandle} />}
    {props.error && (
      <Modal
        title="An Error Occurred"
        onCancelModal={props.onHandle}
        onAcceptModal={props.onHandle}
        acceptEnabled
        button={"accept"}
      >
        <p style={{ fontSize: "1.5rem" }}>{props.error.message}</p>
      </Modal>
    )}
  </Fragment>
);

export default Error;
